<template>
    <div ref="supsisText" id="supsis-text">
        <div class="supsis-popover" :style="{ left, bottom }" v-if="popover">
            <div class="rect"></div>

            <div
                v-if="copyText"
                class="popover-item"
                @click="copyContent"
                :content="'Seçili metni kopyala'"
                v-tippy="{
                    followCursor: true,
                    placement: 'bottom-end',
                    zIndex: 9999999999,
                }"
            >
                <div class="material-icons">content_copy</div>
            </div>
            <div
                v-if="createTask"
                class="popover-item"
                @click="createTaskModal"
                :content="'Seçili metin üzerine görev oluştur'"
                v-tippy="{
                    followCursor: true,
                    placement: 'bottom-end',
                    zIndex: 9999999999,
                }"
            >
                <div class="material-icons">add_task</div>
            </div>
            <div
                v-if="createEvent"
                class="popover-item"
                @click="newEventModalVisible = true"
                :content="'Etkinlik oluştur'"
                v-tippy="{
                    followCursor: true,
                    placement: 'bottom-end',
                    zIndex: 9999999999,
                }"
            >
                <div class="material-icons">edit_calendar</div>
            </div>
            <slot name="items" />
        </div>
        <div ref="supsisTextContent">
            <slot name="content" />
        </div>
        <CreateEventModal
            :eventSummary="getSummary()"
            :calendarList="calendarList"
            v-if="newEventModalVisible"
            @close="newEventModalVisible = false"
        />

    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import CreateEventModal from "../../views/Pages/Calendar/Component/CreateEventModal.vue";
import _ from "lodash";

export default {
    name: "SupsisText",
    components: { CreateEventModal },
    props: {
        message: {
            type: Object,
            required: true,
        },
        visitorId: {
            type: String,
            required: false,
        },
        copyText: {
            type: Boolean,
            default: true,
        },
        createTask: {
            type: Boolean,
            default: true,
        },
        createEvent: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        listener: null,
        popover: false,
        left: 0,
        bottom: 0,
        newEventModalVisible: false,
    }),
    computed: {
        ...mapState({
            calendarList: (state) => state.calendar.calendarList,
        }),
    },
    mounted() {
        this.listener = this.$_.debounce((e) => {
            const supsisText = this.$refs.supsisTextContent;
            const selector = document.getSelection() || window.getSelection();
            this.popover = false;
            if (selector.type === "Range" && supsisText.contains(selector.focusNode)) {
                this.popover = true;
                const getRange = selector.getRangeAt(0);
                const selectionRect = getRange.getBoundingClientRect();
                const rect = supsisText.getBoundingClientRect();
                this.left = selectionRect.left - rect.left + selectionRect.width * 0.5 - 5 + "px";
                this.bottom = rect.bottom - selectionRect.bottom + selectionRect.height + 4 + "px";
            }
        }, 100);
        document.addEventListener("selectionchange", this.listener);
    },
    methods: {
        ...mapActions({
            pinReplyToMessage: "chat/pinReplyToMessage",
            addNewWindow: "app/addNewWindow",
        }),
        getSummary() {
            const selector = document.getSelection() || window.getSelection();
            return selector.toString();
        },
        copyContent() {
            const selector = document.getSelection() || window.getSelection();
            navigator.clipboard.writeText(selector.toString());
            this.$message.success(this.$t("message.copiedClipboard"), 2);
            selector.empty();
        },
        createTaskModal() {
            const selector = document.getSelection() || window.getSelection();
            this.addNewWindow({
                type: "chat-create-task",
                payload: {
                    visitorId: this.visitorId,
                    formDefaults: {
                        title: selector.toString(),
                    },
                    messageId: this.message.raw._id,
                    conversationId: this.getConversationId(),
                },
            });
        },
        getConversationId() {
            return (
                _.get(this.message, "raw.conversation._id") ||
                _.get(this.message, "raw.conversation") ||
                _.get(this.message, "raw.conversationId")
            );
        },
    },
    beforeDestroy() {
        document.removeEventListener("selectionchange", this.listener);
    },
};
</script>
<style lang="scss">
#supsis-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;

    .supsis-popover {
        position: absolute;
        background-color: #242424;
        padding: 10px;
        border-radius: 4px;
        user-select: none;
        z-index: 999999999;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;

        .rect {
            width: 10px;
            height: 10px;
            background-color: #242424;
            position: absolute;
            left: 2px;
            bottom: -2.5px;
            transform: rotate(45deg);
            z-index: 99999999;
        }

        .popover-item {
            display: flex;
            align-items: center;
            cursor: pointer;

            .material-icons {
                color: white;
                font-size: 18px;
            }
        }
    }
}
</style>
